import styled from 'styled-components';
import { LiveStatus } from '../api/client';

// Aviso del estado de la fuente de vivo, contextual a si hay un partido en curso.
//   fuente caída + partido en curso  → cartel ⚠️ "datos demorados"
//   fuente sana + partido en curso   → indicador ● verde "En vivo · actualizado hace Xs"
//   resto (sin partido, vivo apagado) → no muestra nada
export function LiveNotice({
  status,
  hasLive,
  sticky = false,
}: {
  status?: LiveStatus;
  hasLive: boolean;
  sticky?: boolean;
}) {
  if (!status?.enabled || !hasLive) return null;

  if (!status.ok) {
    return (
      <Warn $sticky={sticky}>
        <span className="ico">⚠️</span>
        <span>Sin datos en vivo por el momento — los marcadores pueden estar demorados.</span>
      </Warn>
    );
  }

  return (
    <Ok $sticky={sticky}>
      <span className="dot" />
      <span>En vivo{status.ageSeconds != null ? ` · actualizado hace ${formatAge(status.ageSeconds)}` : ''}</span>
    </Ok>
  );
}

function formatAge(seconds: number): string {
  if (seconds < 60) return `${seconds}s`;
  const min = Math.round(seconds / 60);
  return `${min} min`;
}

// Fijado bajo el header (sticky) cuando se pide: útil en listas con auto-scroll (Partidos),
// para que el aviso no quede por encima del punto al que saltó el scroll.
const stickyCss = `
  position: sticky;
  top: 60px;
  z-index: 9;
`;

const Warn = styled.div<{ $sticky: boolean }>`
  display: flex;
  align-items: center;
  gap: 8px;
  background: ${({ theme }) => theme.colors.surfaceAlt};
  border: 1px solid ${({ theme }) => theme.colors.live};
  border-left: 4px solid ${({ theme }) => theme.colors.live};
  border-radius: ${({ theme }) => theme.radius};
  padding: 10px 12px;
  margin-bottom: 10px;
  font-size: 0.8rem;
  color: ${({ theme }) => theme.colors.text};
  .ico { font-size: 0.95rem; }
  ${({ $sticky }) => ($sticky ? stickyCss : '')}
`;

const Ok = styled.div<{ $sticky: boolean }>`
  display: flex;
  align-items: center;
  gap: 7px;
  margin-bottom: 10px;
  font-size: 0.77rem;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.textMuted};
  ${({ $sticky, theme }) => ($sticky ? stickyCss + `background:${theme.colors.bg};padding:6px 2px;` : '')}
  .dot {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: ${({ theme }) => theme.colors.accent};
    animation: livePulse 1.4s infinite;
  }
  @keyframes livePulse {
    0%, 100% { opacity: 1; }
    50% { opacity: 0.25; }
  }
`;
